import { handleClipboardCopy } from '@/helpers/clipboard'

export default {
  methods: {
    handleClipboardCopy,
  },
}
